<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="user-box">
        <!-- <img class="user-avatar" :src="avatar" alt=""> -->
        <img class="user-avatar" src="@/assets/images/logo.png" alt="">
        <div class="user-name">{{ name }}</div>
        <div class="nav-box" v-for="item in navList" :key="item.id" :class="{ navAct: navCurrent == item.id }"
          @click="chooseNav(item)">
          {{ item.title }}
        </div>
      </div>
      <div class="line"></div>
      <div class="record-box">
        <div v-if="navCurrent == 0">
          <div>
            <el-table border :data="list" stripe style="width: 100%">
              <el-table-column prop="fitem" label="事项名称">
              </el-table-column>
              <el-table-column prop="createDate" label="使用时间">
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px;position: relative;z-index: 99999999999999999;">
            <pagination :useType="1" :total="total" :page.sync="pages" :limit.sync="size" @pagination="init" />
          </div>
        </div>
        <div v-if="navCurrent == 1">
          <div>
            <el-table border :data="sbList" stripe style="width: 100%">
              <el-table-column prop="idx" label="序号" width="50" align="center">
              </el-table-column>
              <el-table-column prop="name" label="事项名称">
              </el-table-column>
              <el-table-column prop="flowId" label="申请流水号">
              </el-table-column>
              <el-table-column prop="userName" label="申请人姓名">
              </el-table-column>
              <el-table-column prop="createDate" label="使用时间">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handleSelect(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px;position: relative;z-index: 99999999999999999;">
            <pagination :useType="1" :total="sbTotal" :page.sync="sbPages" :limit.sync="sbSize"
              @pagination="getSelectBindFlowMaster" />
          </div>
        </div>
      </div>
    </div>
    <Back />
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //
      waitTime: 180,
      watiTimer: null,
      name: '',
      cerno: '',
      avatar: '',
      list: [],
      size: 7,
      pages: 1,
      total: 0,
      navList: [
        {
          id: 0,
          title: '最近使用记录'
        },
        {
          id: 1,
          title: '我的申办'
        }
      ],
      navCurrent: '',
      sbList: [],//事项申报列表
      sbSize: 7,
      sbPages: 1,
      sbTotal: 0,
    };
  },
  created() {
    // this.name = this.$store.state.suerInfo.name
    // this.cerno = this.$store.state.suerInfo.cerno
    // this.avatar = this.$store.state.suerInfo.avatar
    // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    var userInfo = this.$store.state.suerInfo
    this.name = userInfo.name
    this.cerno = userInfo.cerno
    this.avatar = userInfo.avatar
    this.init()
    this.getSelectBindFlowMaster()
  },
  mounted() {
    //
    // this.timeDown()
  },
  destroyed() {
    // console.log('页面销毁');
    clearTimeout(this.watiTimer);
  },
  methods: {
    // 获取申报进度
    getSelectBindFlowMaster() {
      this.$rqt.sxsb_master_selectBindFlowMaster({
        cardId: this.cerno,
        size: this.sbSize,
        current: this.sbPages
      }).then(res => {
        res.data.records.forEach((el, idx) => {
          el.idx = idx + 1
        })
        this.sbList = res.data.records
        this.sbTotal = res.data.total
      })
    },
    // 查看申报详情
    handleSelect(row) {
      this.$router.push({
        path: '/sbInfo',
        query: {
          flowId: row.flowId
        }
      })
    },
    chooseNav(item) {
      this.navCurrent = item.id
    },
    init() {
      this.$rqt.print_getClickRecordList(this.$store.state.suerInfo.cerno, this.pages, this.size).then(res => {
        // console.log(res);
        // res.data fitem
        this.total = res.data.total
        this.list = res.data.records
        // this.list = []
        // res.data.records.forEach((el, idx) => {
        //   if (idx < 10) {
        //     this.list.push(el)
        //   }
        // });
      })
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 180
          clearInterval(this.watiTimer)
          this.$router.replace('/')
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px 5rem;
  background-color: #F1FAFC;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .user-box {
    width: 15%;
    height: calc(100vh - 80rem);
    text-align: center;
    font-size: 5rem;
    line-height: 5rem;

    .user-avatar {
      width: 30rem;
      height: 30rem;
      display: block;
      margin: auto;
      border-radius: 50%;
    }

    .user-name {
      // font-size: 5rem;
      // line-height: 5rem;
      color: #0076C6;
      margin-bottom: 20px;
      font-weight: bold;
    }

    .nav-box {
      width: 100%;
      padding: 4rem 0;
      color: #333333;
    }

    .navAct {
      background-color: #52AEFE;
      color: #F4F3F3;
    }
  }

  .record-box {
    width: 84%;
    height: calc(100vh - 80rem);
    background-color: #fff;
    overflow: hidden;

    .record-title {
      font-size: 6rem;
      color: #295eb5;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}


.line {
  width: 0;
  height: 60vh;
  border-right: 1px solid rgba($color: #000000, $alpha: .1);
}

.record-item {
  font-size: 5rem;
  margin-bottom: 20px;
}
</style>